import React, { useState, useEffect } from "react";
import "./EditAgentModal.css";
import EditUserModal from "../EditUserModal/EditUserModal";
import ConfirmActionModal from "../ConfirmActionModal/ConfirmActionModal";
import HistoryDetailModal from "../HistoryDetailModal/HistoryDetailModal";
import ConfirmCreateModal from "../ConfirmCreateModal/ConfirmCreateModal";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import vi from "date-fns/locale/vi";
// 1. Import Hook phân quyền
import { useRolePermission } from "../../hooks/useRolePermission";
import { useToast } from "../Toast/ToastContainer";

registerLocale("vi", vi);

const TABS = [
    "Thông tin Đại lý",
    "Hạn mức",
    "Thông tin User",
    "Lịch sử Đại lý",
    "Lịch sử User",
    "Hồ sơ đăng ký",
];
const CITIES = [
    "Hồ Chí Minh", "Hà Nội", "Đà Nẵng", "Cần Thơ", "Hải Phòng",
    "Bình Dương", "Đồng Nai", "Bà Rịa - Vũng Tàu", "Khánh Hòa",
    "Lâm Đồng", "Thừa Thiên Huế", "Quảng Ninh", "Nghệ An"
];
export default function EditAgentModal({ isOpen, onClose, agent, onSave }) {
    const [activeTab, setActiveTab] = useState("Thông tin Đại lý");
    const [isUserModalOpen, setIsUserModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [docs, setDocs] = useState([]);

    // State cho Modal xác nhận User
    const [openUserActionModal, setOpenUserActionModal] = useState(false);
    const [selectedUserAction, setSelectedUserAction] = useState(null);
    const [userActionType, setUserActionType] = useState("");

    // State cho Lịch sử
    const [userHistoryDetail, setUserHistoryDetail] = useState(null);
    const [isUserHistoryDetailOpen, setIsUserHistoryDetailOpen] = useState(false);

    // 2. State cho Form & Users
    const [form, setForm] = useState(agent || {});
    const [users, setUsers] = useState([]); // Thay mock data bằng mảng rỗng
    const [isLoadingUsers, setIsLoadingUsers] = useState(false);

    const [savedDocs, setSavedDocs] = useState([]);
    const [isLoadingDocs, setIsLoadingDocs] = useState(false);

    const [history, setHistory] = useState([]);
    const [isLoadingHistory, setIsLoadingHistory] = useState(false);
    // --- MỚI: State Lịch sử User ---
    const [userHistory, setUserHistory] = useState([]);
    const [isLoadingUserHistory, setIsLoadingUserHistory] = useState(false);
    // --- MỚI: State cho Hạn mức ---
    const [scheduledLimit, setScheduledLimit] = useState(null); // Lưu thông tin limit đang chờ duyệt (nếu có)
    const [isLoadingLimit, setIsLoadingLimit] = useState(false);
    // --- MỚI: State cho Modal xác nhận xóa file ---
    const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);
    const [docToDelete, setDocToDelete] = useState(null);
    const [accountOptions, setAccountOptions] = useState([]);
    // 3. Lấy quyền hạn
    const { permissions } = useRolePermission();
    const toast = useToast(); // Khởi tạo toast

    // Reset Form khi mở modal
    useEffect(() => {
        if (agent) {
            // Lưu ý: Đảm bảo dữ liệu agent từ cha truyền vào đã được format đúng
            // Ví dụ: hanMucNgay đang là chuỗi "200.000.000 VND" thì cần xử lý cắt chuỗi nếu Select box chỉ nhận value số
            setForm(agent);
        } else {
            setForm({});
        }
    }, [agent, isOpen]);

    // Reset User List khi đóng/mở modal
    // Fetch dữ liệu khi chuyển tab
    useEffect(() => {
        if (!isOpen) {
            setActiveTab("Thông tin Đại lý");
            setSavedDocs([]);
            setScheduledLimit(null);
            setAccountOptions([]);
        } else {
            if (!agent?.id) return;

            // --- MỚI: Fetch Accounts ngay khi mở (dùng CIF của Đại lý) ---
            // Giả định field CIF trong object agent là `cifDltt` hoặc `cif_number`
            const cif = agent.cifDltt || agent.cif_number;
            if (cif) {
                fetchAccounts(cif);
            }

            if (activeTab === "Thông tin User") fetchUsers();
            if (activeTab === "Hồ sơ đăng ký") fetchDocuments();
            if (activeTab === "Lịch sử Đại lý") fetchHistory();
            if (activeTab === "Lịch sử User") fetchUserHistory();
            if (activeTab === "Hạn mức") fetchLimits();
        }
    }, [isOpen, activeTab, agent]);
    // --- HELPER CALL API ---
    const callApi = async (url, method = "GET", body = null) => {
        const token = localStorage.getItem("access_token");
        const headers = { "Authorization": `Bearer ${token}` };
        if (body && !(body instanceof FormData)) {
            headers["Content-Type"] = "application/json";
        }
        try {
            const res = await fetch(url, { method, headers, body: body instanceof FormData ? body : (body ? JSON.stringify(body) : null) });
            if (!res.ok) throw new Error("Lỗi gọi API");
            return await res.json();
        } catch (error) {
            console.error(error);
            return null;
        }
    };

    // --- API: FETCH ACCOUNTS (Để đổ vào Dropdown) ---
    const fetchAccounts = async (cif) => {
        try {
            const token = localStorage.getItem("access_token");
            const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/agents/accounts/${cif}`, {
                headers: { "Authorization": `Bearer ${token}` }
            });
            if (response.ok) {
                const data = await response.json();
                if (Array.isArray(data)) {
                    setAccountOptions(data);
                }
            }
        } catch (error) {
            console.error("Error fetching accounts:", error);
        }
    };

    // --- API: UPDATE AGENT INFO (PUT) ---
    const handleUpdateAgentInfo = async () => {
        // Validate
        if (!form.taiKhoanGiaoDich || !form.diaChiChiTiet) {
            return toast.warning("Vui lòng điền các trường bắt buộc!");
        }

        try {
            const token = localStorage.getItem("access_token");

            // Map state form sang payload API yêu cầu
            const payload = {
                account_number: form.taiKhoanGiaoDich,
                address: form.diaChiChiTiet,
                agent_phone: form.agentPhone,         // Sửa: Thêm SĐT Đại lý
                region: form.khuVuc,                  // Sửa: Thêm Khu vực

                representative_cif: form.cifNguoiDaiDien,
                representative_name: form.tenNguoiDaiDien, // Sửa: Tên người đại diện (editable)
                representative_phone: form.sdtNguoiDaiDien,

                manager_code: form.maCbnvQuanLy,
                manager_name: form.tenCbnvQuanLy,

                business_unit_code: form.maDvkdPhatTrien,
                business_unit_name: form.tenDvkdPhatTrien
            };

            const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/agents/${agent.id}`, {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const err = await response.json();
                throw new Error(err.detail || "Lỗi khi cập nhật thông tin");
            }

            toast.success("Cập nhật thông tin đại lý thành công!");
            onSave(form); // Reload list ở cha

        } catch (error) {
            console.error(error);
            toast.error(error.message);
        }
    };
    // --- LOOKUP FUNCTIONS (Hỗ trợ khi sửa) ---
    const handleLookupRepCif = async () => {
        if (!form.cifNguoiDaiDien) return toast.warning("Nhập CIF người đại diện");
        const data = await callApi(`https://api.bvb.cybertech.com.vn/api/v1/admin/agents/lookup/representative/${form.cifNguoiDaiDien}`);
        if (data) {
            setForm(prev => ({
                ...prev,
                tenNguoiDaiDien: data.full_name,
                sdtNguoiDaiDien: data.phone
            }));
            toast.success("Đã cập nhật người đại diện");
        }
    };
    const handleBlurManagerCode = async () => {
        if (!form.maCbnvQuanLy) return;
        const data = await callApi(`https://api.bvb.cybertech.com.vn/api/v1/admin/agents/lookup/bank-staffs/${form.maCbnvQuanLy}`);
        if (data) setForm(prev => ({ ...prev, tenCbnvQuanLy: data.staff_name }));
    };

    const handleBlurDvkdCode = async () => {
        if (!form.maDvkdPhatTrien) return;
        const data = await callApi(`https://api.bvb.cybertech.com.vn/api/v1/admin/agents/lookup/business-unit/${form.maDvkdPhatTrien}`);
        if (data) setForm(prev => ({ ...prev, tenDvkdPhatTrien: data.business_unit_name }));
    };
    // --- MỚI: Hàm fetch documents ---
    const fetchDocuments = async () => {
        setIsLoadingDocs(true);
        try {
            const token = localStorage.getItem("access_token");
            const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/agents/${agent.id}/documents`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
            if (!response.ok) throw new Error("Failed to fetch documents");
            const data = await response.json();
            const list = Array.isArray(data) ? data : (data.data || []);
            setSavedDocs(list);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoadingDocs(false);
        }
    };

    // Helper format size
    const formatFileSize = (bytes) => {
        if (!bytes) return "0 B";
        const k = 1024;
        const sizes = ["B", "KB", "MB", "GB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };
    // 4. Hàm gọi API lấy danh sách User (Giống AgentDetailModal)
    const fetchUsers = async () => {
        setIsLoadingUsers(true);
        try {
            const token = localStorage.getItem("access_token");
            const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/users/users/agent/${agent.id}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            if (!response.ok) {
                throw new Error("Failed to fetch users");
            }

            const data = await response.json();
            console.log("edit user", data);
            const userList = Array.isArray(data) ? data : (data.data || []);
            setUsers(userList);

        } catch (error) {
            console.error("Error fetching users:", error);
        } finally {
            setIsLoadingUsers(false);
        }
    };

    const statusClass = (status) => {
        switch (status) {
            case "Hoạt động": return "status-active";
            case "ACTIVE": return "status-active";
            case "Đóng": return "status-closed";
            case "CLOSED": return "status-closed";
            case "Tạm khóa": return "status-lock";
            case "LOCKED": return "status-lock";

            // Bổ sung case này:
            case "Chờ kích hoạt":
            case "PENDING":
            case "WAITING_ACTIVATION": return "status-pending"; // Dùng class CSS màu cam/vàng

            default: return "";
        }
    };
    // --- MỚI: HÀM XỬ LÝ GỌI API ĐỔI TRẠNG THÁI USER ---
    const handleConfirmUserStatus = async (reason) => {
        if (!selectedUserAction || !userActionType) return;

        // 1. Map action UI sang API Action
        // UI: lock, unlock, close
        // API: LOCK, UNLOCK, CLOSE
        const actionMap = {
            lock: "LOCK",
            unlock: "UNLOCK",
            close: "CLOSE",
            activate: "ACTIVATE" // Dự phòng nếu sau này có nút kích hoạt
        };

        const apiAction = actionMap[userActionType];

        if (!apiAction) {
            toast.error("Hành động không hợp lệ");
            return;
        }

        try {
            const token = localStorage.getItem("access_token");
            // API: POST /api/v1/admin/users/users/{id}/status?action={ACTION}
            const url = `https://api.bvb.cybertech.com.vn/api/v1/admin/users/users/${selectedUserAction.id}/status?action=${apiAction}`;

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                // Gửi lý do vào body (nếu backend support log lý do)
                body: JSON.stringify({ reason })
            });

            if (!response.ok) {
                const errData = await response.json().catch(() => ({}));
                throw new Error(errData.detail || "Lỗi khi cập nhật trạng thái User");
            }

            // 2. Thành công
            toast.success(`Cập nhật trạng thái User thành công!`);
            setOpenUserActionModal(false);

            // 3. Reload lại danh sách User ngay lập tức
            fetchUsers();

        } catch (error) {
            console.error("User Status Error:", error);
            toast.error(error.message);
        }
    };
    // --- MỚI: Hàm fetch History ---
    const fetchHistory = async () => {
        setIsLoadingHistory(true);
        try {
            const token = localStorage.getItem("access_token");
            const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/agents/${agent.id}/history`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
            if (!response.ok) throw new Error("Failed to fetch history");
            const data = await response.json();
            setHistory(data || []);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoadingHistory(false);
        }
    };

    const mapActionType = (type) => {
        const map = { "LOCK": "Khóa", "UNLOCK": "Mở khóa", "CLOSE": "Đóng", "CREATE": "Tạo mới", "UPDATE": "Cập nhật", "ACTIVATE": "Kích hoạt" };
        return map[type] || type;
    };

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        return dateString.replace("T", " ");
    };
    const fetchUserHistory = async () => {
        setIsLoadingUserHistory(true);
        try {
            const token = localStorage.getItem("access_token");
            const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/users/users/agent/${agent.id}/history`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
            if (!response.ok) throw new Error("Failed");
            const data = await response.json();
            setUserHistory(data || []);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoadingUserHistory(false);
        }
    };
    // Logic xem chi tiết
    const handleViewHistoryDetail = (item) => {
        // Map Action Type sang tiếng Việt cho đẹp
        const mapAction = {
            "LOCK": "Khóa",
            "UNLOCK": "Mở khóa",
            "UPDATE": "Cập nhật",
            // ...
        };

        const detailData = {
            fieldName: mapAction[item.action_type] || item.action_type, // Hiển thị tên thao tác
            oldValue: item.old_value, // Truyền thẳng object {status: "ACTIVE"}
            newValue: item.new_value  // Truyền thẳng object {status: "LOCKED"}
        };

        // Gọi hàm set state để mở modal
        if (typeof handleUserHistoryDetail === 'function') {
            handleUserHistoryDetail(detailData);
        }
    };
    // --- API 1: GET LIMITS ---
    // --- API 1: GET LIMITS ---
    const fetchLimits = async () => {
        setIsLoadingLimit(true);
        try {
            const token = localStorage.getItem("access_token");
            const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/agents/${agent.id}/limits?t=${new Date().getTime()}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            if (!response.ok) throw new Error("Lỗi khi lấy thông tin hạn mức");

            const data = await response.json();

            // --- LOG DATA Ở ĐÂY ---
            console.log(">>> API Limit Response:", data);

            let displayDaily = data.current_daily_limit;
            let displayMonthly = data.current_monthly_limit;
            let displayDate = null;
            let pendingInfo = null;

            if (data.scheduled && data.scheduled.length > 0) {
                const sortedScheduled = data.scheduled.sort((a, b) => b.id - a.id);
                const latestSchedule = sortedScheduled[0];

                console.log(">>> Latest Scheduled Record:", latestSchedule);

                if (latestSchedule.status === 'PENDING' || latestSchedule.status === 'SCHEDULED') {
                    displayDaily = latestSchedule.daily_limit;
                    displayMonthly = latestSchedule.monthly_limit;
                    displayDate = latestSchedule.effective_date; // Đây là biến quan trọng
                    pendingInfo = latestSchedule;
                }
            }

            console.log(">>> Value to be set for DatePicker:", displayDate);

            setForm(prev => ({
                ...prev,
                hanMucNgay: parseInt(displayDaily),
                hanMucThang: parseInt(displayMonthly),
                // Gán giá trị ngày vào state
                ngayHieuLucHanMuc: displayDate
            }));

            setScheduledLimit(pendingInfo);

        } catch (error) {
            console.error("Fetch Limit Error:", error);
        } finally {
            setIsLoadingLimit(false);
        }
    };
    // Helper đặt bên trong component
    const parseDateString = (dateStr) => {
        if (!dateStr) return null;
        if (typeof dateStr === 'object') return dateStr; // Nếu đã là Date object

        // Cắt chuỗi lấy phần YYYY-MM-DD
        const cleanStr = dateStr.includes("T") ? dateStr.split("T")[0] : dateStr;
        const [year, month, day] = cleanStr.split('-').map(Number);

        // Tạo Date theo giờ địa phương (không dùng UTC)
        return new Date(year, month - 1, day);
    };
    // --- API 2: PUT LIMITS (UPDATE) ---
    const handleUpdateLimits = async () => {
        // Validate ngày hiệu lực
        if (!form.ngayHieuLucHanMuc) {
            toast.warning("Vui lòng chọn ngày hiệu lực hạn mức!");
            return;
        }

        try {
            const token = localStorage.getItem("access_token");

            // Format date sang YYYY-MM-DD
            const dateObj = new Date(form.ngayHieuLucHanMuc);
            const formattedDate = dateObj.toISOString().split('T')[0];

            const payload = {
                daily_limit: parseInt(form.hanMucNgay),
                monthly_limit: parseInt(form.hanMucThang),
                effective_date: formattedDate
            };

            const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/agents/${agent.id}/limits`, {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const err = await response.json();
                throw new Error(err.detail || "Lỗi khi cập nhật hạn mức");
            }

            const resData = await response.json();

            // Xử lý thông báo dựa trên Status trả về
            if (resData.status === "APPLIED") {
                toast.success("Cập nhật hạn mức thành công (Áp dụng ngay)!");
            } else if (resData.status === "SCHEDULED" || resData.status === "UPDATED_SCHEDULE") {
                toast.success(`Đã lên lịch cập nhật hạn mức vào ngày ${formattedDate}`);
            }

            // Fetch lại để cập nhật giao diện (ví dụ hiện thông báo Scheduled mới)
            fetchLimits();

        } catch (error) {
            console.error(error);
            toast.error(error.message);
        }
    };
    // Hàm xử lý tải file về máy
    const handleDownloadFile = async (e, fileUrl, fileName) => {
        e.preventDefault(); // Chặn hành vi mở tab mới mặc định

        try {
            // 1. Tải file về dưới dạng dữ liệu thô (Blob)
            const response = await fetch(fileUrl);
            const blob = await response.blob();

            // 2. Tạo đường dẫn ảo
            const url = window.URL.createObjectURL(blob);

            // 3. Tạo thẻ a ảo để kích hoạt tải xuống
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName || "tai_lieu";
            document.body.appendChild(link);
            link.click();

            // 4. Dọn dẹp
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Lỗi download:", error);
            // Fallback: Nếu lỗi (ví dụ do CORS), mở tab mới để người dùng tự lưu
            window.open(fileUrl, "_blank");
        }
    };
    // --- XỬ LÝ NÚT SAVE CHUNG ---
    const handleSaveClick = () => {
        if (activeTab === "Hạn mức") {
            handleUpdateLimits();
        } else if (activeTab === "Thông tin Đại lý") {
            handleUpdateAgentInfo(); // Gọi API PUT Update Agent
        } else {
            onSave(form);
        }
    };
    // Helper format tiền tệ cho Scheduled Info
    const formatMoney = (amount) => {
        return Number(amount).toLocaleString('vi-VN') + " VND";
    };
    const handleUserHistoryDetail = (detail) => {
        setUserHistoryDetail(detail);
        setIsUserHistoryDetailOpen(true);
    };

    const openEditUser = (user) => {
        setSelectedUser(user);
        setIsUserModalOpen(true);
    };

    const openUserAction = (user, type) => {
        setSelectedUserAction(user);
        setUserActionType(type);
        setOpenUserActionModal(true);
    };

    const userActionMessage = {
        lock: "Bạn có chắc chắn muốn khóa người dùng này?",
        unlock: "Bạn có chắc chắn muốn mở khóa người dùng này?",
        close: "Bạn có chắc chắn muốn đóng người dùng này?",
    };
    // Trong EditAgentModal.jsx

    // 5. Render Action Buttons dựa trên Quyền và Trạng thái
    const renderUserActions = (u) => {
        if (!permissions.canEdit) return null;

        const status = u.status;
        // Map status linh hoạt cả tiếng Anh và tiếng Việt
        const isActive = status === "Hoạt động" || status === "ACTIVE";
        const isPending = status === "Chờ kích hoạt" || status === "PENDING" || status === "WAITING_ACTIVATION";
        const isLocked = status === "Tạm khóa" || status === "LOCKED";

        // Logic hiển thị nút dựa trên bảng status bạn cung cấp:
        // ACTIVE/WAITING -> Có thể LOCK, CLOSE
        // LOCKED -> Có thể UNLOCK, CLOSE

        if (isActive || isPending) {
            return (
                <>
                    <img src="/icons/icons8-pencil-100.png" className="edit-user-icon" title="Chỉnh sửa" onClick={() => openEditUser(u)} />
                    <img src="/icons/icons8-lock-100.png" className="edit-user-icon" title="Khóa user" onClick={() => openUserAction(u, "lock")} />
                    <img src="/icons/icons8-block-100.png" className="edit-user-icon" title="Đóng user" onClick={() => openUserAction(u, "close")} />
                </>
            );
        }

        if (isLocked) {
            return (
                <>
                    <img src="/icons/icons8-unlock-100.png" className="edit-user-icon" title="Mở khóa user" onClick={() => openUserAction(u, "unlock")} />
                    <img src="/icons/icons8-block-100.png" className="edit-user-icon" title="Đóng user" onClick={() => openUserAction(u, "close")} />
                </>
            );
        }
        return null;
    };

    // --- API UPLOAD FILE (Gọi ngay khi chọn file) ---
    const handleDocUpload = async (e) => {
        const selectedFiles = Array.from(e.target.files);
        e.target.value = null; // Reset input

        if (selectedFiles.length === 0) return;

        // Validate cơ bản (dung lượng, số lượng...)
        const oversized = selectedFiles.filter(f => f.size > 10 * 1024 * 1024);
        if (oversized.length > 0) {
            toast.warning("File không được quá 10MB");
            return;
        }

        setIsLoadingDocs(true);
        try {
            const token = localStorage.getItem("access_token");

            // API hỗ trợ upload nhiều file 1 lúc hay từng file? 
            // Dựa vào Curl mẫu bạn đưa (files=@...), thường là upload từng file hoặc 1 mảng.
            // Ở đây tôi viết vòng lặp để upload từng file (an toàn nhất) 
            // hoặc gửi 1 request nếu API backend support multiple files key 'files'.

            // Cách 1: Upload từng file (Giả định API nhận 1 file/request hoặc xử lý loop)
            for (const file of selectedFiles) {
                const formData = new FormData();
                formData.append('files', file); // Key khớp với curl: files=@...

                const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/agents/${agent.id}/documents`, {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${token}`
                        // Không set Content-Type để browser tự set boundary
                    },
                    body: formData
                });

                if (!response.ok) {
                    throw new Error(`Lỗi khi upload file ${file.name}`);
                }
            }

            toast.success("Upload hồ sơ thành công!");

            // Reload lại danh sách ngay lập tức
            fetchDocuments();

        } catch (error) {
            console.error(error);
            toast.error("Có lỗi xảy ra khi upload");
        } finally {
            setIsLoadingDocs(false);
        }
    };

    // --- MỚI: HÀM MỞ MODAL XÓA ---
    const handleDeleteClick = (docId) => {
        setDocToDelete(docId);
        setIsConfirmDeleteOpen(true);
    };

    // --- MỚI: HÀM THỰC THI XÓA (GỌI API) ---
    const executeDeleteDoc = async () => {
        if (!docToDelete) return;

        try {
            const token = localStorage.getItem("access_token");
            const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/agents/${agent.id}/documents/${docToDelete}`, {
                method: "DELETE",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "accept": "application/json"
                }
            });

            if (!response.ok) throw new Error("Lỗi khi xóa hồ sơ");

            toast.success("Đã xóa hồ sơ");
            fetchDocuments(); // Reload list

        } catch (error) {
            console.error(error);
            toast.error("Không thể xóa hồ sơ");
        } finally {
            // Đóng modal & reset state
            setIsConfirmDeleteOpen(false);
            setDocToDelete(null);
        }
    };
    const handlePhoneInput = (key, val) => {
        if (!/^\d*$/.test(val)) return;
        if (val.length > 10) return;
        update(key, val);
    };
    const update = (k, v) => setForm({ ...form, [k]: v });
    const stop = (e) => e.stopPropagation();

    if (!isOpen) return null;

    return (
        <div className="edit-agent-overlay" onClick={onClose}>
            <div className="edit-agent-modal" onClick={stop}>

                {/* =============== HEADER =============== */}
                <div className="edit-agent-header">
                    <h3>Sửa thông tin Đại lý – {form?.idDltt}</h3>
                    <button className="edit-agent-close" onClick={onClose}>✕</button>
                </div>

                {/* =============== TABS =============== */}
                <div className="edit-agent-tabs">
                    {TABS.map((tab) => (
                        <button
                            key={tab}
                            className={
                                "edit-agent-tab" +
                                (activeTab === tab ? " edit-agent-tab-active" : "")
                            }
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                {/* =============== CONTENT AREA =============== */}
                <div className="edit-agent-content">

                    {/* ========== TAB 1 — SỬA THÔNG TIN ĐẠI LÝ (CẬP NHẬT) ========== */}
                    {activeTab === "Thông tin Đại lý" && (
                        <div className="edit-info-container">
                            <h3 className="edit-info-title">Thông tin chung</h3>
                            <div className="edit-info-grid">

                                {/* Checkbox đại lý trung tâm - DISABLED */}
                                <div className="edit-info-field full edit-info-checkbox-row">
                                    <label className="edit-info-checkbox-label">
                                        <input
                                            type="checkbox"
                                            checked={form.isCenter || false}
                                            disabled // Không được sửa
                                        />
                                        <span>ĐẠI LÝ TRUNG TÂM</span>
                                    </label>
                                </div>

                                {/* CIF Chủ quản - READONLY */}
                                <div className="edit-info-field">
                                    <label>CIF Đại lý chủ quản</label>
                                    <input type="text" value={form.cifAgentParent || ""} readOnly className="read-only-field" />
                                </div>
                                <div className="edit-info-field">
                                    <label>Tên Đại lý chủ quản</label>
                                    <input type="text" value={form.tenAgentChuQuan || ""} readOnly className="read-only-field" />
                                </div>

                                {/* CIF Thanh toán - READONLY */}
                                <div className="edit-info-field">
                                    <label>CIF Đại lý thanh toán</label>
                                    <input type="text" value={form.cifDltt || ""} readOnly className="read-only-field" />
                                </div>
                                <div className="edit-info-field">
                                    <label>Tên Đại lý thanh toán</label>
                                    <input type="text" value={form.tenDltt || ""} readOnly className="read-only-field" />
                                </div>

                                {/* ID Đại lý - READONLY */}
                                <div className="edit-info-field">
                                    <label>ID Đại lý thanh toán</label>
                                    <input type="text" value={form.idDltt || ""} readOnly className="read-only-field" />
                                </div>

                                {/* Tài khoản giao dịch - DROPDOWN */}
                                <div className="edit-info-field">
                                    <label>Tài khoản giao dịch <span className="required">*</span></label>
                                    <select
                                        value={form.taiKhoanGiaoDich || ""}
                                        onChange={(e) => update("taiKhoanGiaoDich", e.target.value)}
                                    >
                                        <option value="">Chọn tài khoản</option>
                                        {/* Hiển thị danh sách lấy từ API */}
                                        {accountOptions.map((opt, idx) => (
                                            <option key={idx} value={opt.account_number}>
                                                {opt.account_number} - {opt.account_name}
                                            </option>
                                        ))}
                                        {/* Nếu tài khoản hiện tại không có trong list (trường hợp data cũ), force hiển thị nó */}
                                        {form.taiKhoanGiaoDich && !accountOptions.find(o => o.account_number === form.taiKhoanGiaoDich) && (
                                            <option value={form.taiKhoanGiaoDich}>{form.taiKhoanGiaoDich}</option>
                                        )}
                                    </select>
                                </div>

                                {/* Trạng thái - DISABLED */}
                                <div className="edit-info-field">
                                    <label>Trạng thái</label>
                                    <input type="text" value={form.trangThai || ""} disabled className="read-only-field" />
                                </div>

                                <div className="edit-info-field">
                                    <label>Số điện thoại Đại lý</label>
                                    <input
                                        type="text"
                                        value={form.agentPhone || ""}
                                        onChange={(e) => handlePhoneInput("agentPhone", e.target.value)}
                                    />
                                </div>

                                {/* Khu vực - SELECT COMBOBOX (Sửa ở đây) */}
                                <div className="edit-info-field">
                                    <label>Khu vực (Tỉnh/TP)</label>
                                    <select
                                        value={form.khuVuc || ""}
                                        onChange={(e) => update("khuVuc", e.target.value)}
                                    >
                                        <option value="">Chọn Tỉnh/Thành phố</option>
                                        {CITIES.map((city, idx) => (
                                            <option key={idx} value={city}>{city}</option>
                                        ))}
                                        {/* Fallback nếu data cũ không nằm trong list */}
                                        {form.khuVuc && !CITIES.includes(form.khuVuc) && (
                                            <option value={form.khuVuc}>{form.khuVuc}</option>
                                        )}
                                    </select>
                                </div>

                                {/* Địa chỉ - EDITABLE */}
                                <div className="edit-info-field">
                                    <label>Địa chỉ Đại lý <span className="required">*</span></label>
                                    <input type="text" value={form.diaChiChiTiet || ""} onChange={(e) => update("diaChiChiTiet", e.target.value)} />
                                </div>

                                {/* Người đại diện - EDITABLE & LOOKUP */}
                                <div className="edit-info-field">
                                    <label>CIF người đại diện <span className="required">*</span></label>
                                    <div className="edit-info-input-icon">
                                        <input
                                            type="text"
                                            value={form.cifNguoiDaiDien || ""}
                                            onChange={(e) => update("cifNguoiDaiDien", e.target.value)}
                                        />
                                        <span className="edit-info-search-icon" onClick={handleLookupRepCif} title="Tìm kiếm"></span>
                                    </div>
                                </div>
                                {/* Tên người đại diện - EDITABLE (Sửa ở đây) */}
                                <div className="edit-info-field">
                                    <label>Tên người đại diện ĐLTT <span className="required">*</span></label>
                                    <input
                                        type="text"
                                        value={form.tenNguoiDaiDien || ""}
                                        onChange={(e) => update("tenNguoiDaiDien", e.target.value)}
                                    />
                                </div>
                                <div className="edit-info-field">
                                    <label>SĐT người đại diện <span className="required">*</span></label>
                                    <input
                                        type="text"
                                        value={form.sdtNguoiDaiDien || ""}
                                        onChange={(e) => handlePhoneInput("sdtNguoiDaiDien", e.target.value)}
                                    />
                                </div>
                                <div className="ac-field empty-cell"></div>

                                {/* CBNV Quản lý - EDITABLE & LOOKUP */}
                                <div className="edit-info-field">
                                    <label>Mã CBNV BVBank quản lý <span className="required">*</span></label>
                                    <input
                                        type="text"
                                        value={form.maCbnvQuanLy || ""}
                                        onChange={(e) => update("maCbnvQuanLy", e.target.value)}
                                        onBlur={handleBlurManagerCode}
                                    />
                                </div>
                                <div className="edit-info-field">
                                    <label>Tên CBNV BVBank quản lý</label>
                                    <input type="text" value={form.tenCbnvQuanLy || ""} readOnly className="read-only-field" />
                                </div>

                                {/* ĐVKD - EDITABLE & LOOKUP */}
                                <div className="edit-info-field">
                                    <label>Mã ĐVKD phát triển <span className="required">*</span></label>
                                    <input
                                        type="text"
                                        value={form.maDvkdPhatTrien || ""}
                                        onChange={(e) => update("maDvkdPhatTrien", e.target.value)}
                                        onBlur={handleBlurDvkdCode}
                                    />
                                </div>
                                <div className="edit-info-field">
                                    <label>Tên ĐVKD phát triển</label>
                                    <input type="text" value={form.tenDvkdPhatTrien || ""} readOnly className="read-only-field" />
                                </div>

                                {/* Thông tin System - READONLY */}
                                <div className="edit-info-field"><label>Người tạo</label><input type="text" value={form.nguoiTao || ""} readOnly className="read-only-field" /></div>
                                <div className="edit-info-field"><label>Thời gian tạo</label><input type="text" value={form.thoiGianTao || ""} readOnly className="read-only-field" /></div>
                                <div className="edit-info-field"><label>Người chỉnh sửa gần nhất</label><input type="text" value={form.nguoiChinhSuaGanNhat || ""} readOnly className="read-only-field" /></div>
                                <div className="edit-info-field"><label>Thời gian chỉnh sửa gần nhất</label><input type="text" value={form.thoiGianChinhSuaGanNhat || ""} readOnly className="read-only-field" /></div>
                            </div>
                        </div>
                    )}
                    {/* TAB 2: HẠN MỨC (CẬP NHẬT) */}
                    {activeTab === "Hạn mức" && (
                        <div className="edit-limit-form">
                            <div className="edit-limit-row">
                                <div className="edit-limit-col">
                                    <label>Hạn mức ngày <span className="required">*</span></label>
                                    <select
                                        className="edit-limit-dropdown"
                                        value={form.hanMucNgay}
                                        onChange={(e) => update("hanMucNgay", e.target.value)}
                                        disabled={isLoadingLimit}
                                    >
                                        <option value="100000000">100.000.000 VND</option>
                                        <option value="200000000">200.000.000 VND</option>
                                        <option value="300000000">300.000.000 VND</option>
                                        <option value="500000000">500.000.000 VND</option>
                                        {/* Option ẩn để hiển thị giá trị hiện tại nếu khác list */}
                                        <option value={form.hanMucNgay} hidden>{formatMoney(form.hanMucNgay)}</option>
                                    </select>
                                </div>
                                <div className="edit-limit-col">
                                    <label>Hạn mức tháng <span className="required">*</span></label>
                                    <select
                                        className="edit-limit-dropdown"
                                        value={form.hanMucThang}
                                        onChange={(e) => update("hanMucThang", e.target.value)}
                                        disabled={isLoadingLimit}
                                    >
                                        <option value="5000000000">5.000.000.000 VND</option>
                                        <option value="10000000000">10.000.000.000 VND</option>
                                        <option value={form.hanMucThang} hidden>{formatMoney(form.hanMucThang)}</option>
                                    </select>
                                </div>
                            </div>
                            <div className="edit-limit-row">
                                <div className="edit-limit-col">
                                    <label>Ngày hiệu lực hạn mức <span className="required">*</span></label>
                                    <div className="edit-limit-date-wrapper">
                                        <img src="/icons/icons8-calendar-100.png" className="edit-limit-date-icon" alt="" />
                                        <DatePicker
                                            // Fix: Parse chuỗi YYYY-MM-DD thành Date object an toàn
                                            selected={
                                                form.ngayHieuLucHanMuc
                                                    ? new Date(form.ngayHieuLucHanMuc)
                                                    : null
                                            }
                                            // Fix: Khi chọn ngày, convert ngay sang định dạng YYYY-MM-DD (local time) để lưu vào state
                                            onChange={(date) => {
                                                if (date) {
                                                    // Format thủ công để tránh lệch múi giờ
                                                    const y = date.getFullYear();
                                                    const m = String(date.getMonth() + 1).padStart(2, '0');
                                                    const d = String(date.getDate()).padStart(2, '0');
                                                    update("ngayHieuLucHanMuc", `${y}-${m}-${d}`);
                                                } else {
                                                    update("ngayHieuLucHanMuc", null);
                                                }
                                            }}
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="dd/mm/yyyy"
                                            className="edit-limit-date-input"
                                            locale="vi"
                                            minDate={new Date()}
                                        />
                                    </div>
                                </div>
                                <div className="edit-limit-col" />
                            </div>
                        </div>
                    )}
                    {activeTab === "Thông tin User" && (
                        <div className="edit-user-container">
                            <table className="edit-user-table">
                                <thead>
                                    <tr>
                                        <th>Thao tác</th>
                                        <th>Username</th>
                                        <th>User ID</th>
                                        <th>Mã KH (CIF)</th> {/* Sửa label cho rõ */}
                                        <th>Nhóm quyền</th>
                                        <th>Trạng thái</th>
                                        <th>User tạo</th>      {/* Thêm cột này */}
                                        <th>Branch tạo</th>    {/* Thêm cột này */}
                                        <th>Ngày tạo</th>      {/* Thêm cột này */}
                                        <th>CBNV quản lý</th>  {/* Cột cũ của bạn */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoadingUsers && (
                                        <tr><td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>Đang tải dữ liệu...</td></tr>
                                    )}
                                    {!isLoadingUsers && users.length === 0 && (
                                        <tr><td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>Không có dữ liệu user</td></tr>
                                    )}
                                    {!isLoadingUsers && users.map((u, idx) => (
                                        <tr key={u.id || idx} className={idx === 0 ? "edit-user-row-highlight" : ""}>
                                            <td className="edit-user-actions">
                                                {renderUserActions(u)}
                                            </td>
                                            <td>{u.username}</td>
                                            <td>{u.id}</td>

                                            {/* SỬA: Map đúng field cif_number */}
                                            <td>{u.cif_number || u.cif || u.customerCode || ""}</td>

                                            <td>{u.role}</td>

                                            <td>
                                                <span className={`edit-user-status ${statusClass(u.status)}`}>
                                                    {u.status}
                                                </span>
                                            </td>

                                            {/* THÊM MỚI: Các cột thông tin tạo */}
                                            <td>{u.created_by}</td>
                                            <td>{u.branch_created || u.branch_code || ""}</td>
                                            <td>{u.created_at ? formatDate(u.created_at) : ""}</td>

                                            <td>{u.full_name || u.manager_code || ""}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                    {/* --- CẬP NHẬT TAB LỊCH SỬ ĐẠI LÝ --- */}
                    {activeTab === "Lịch sử Đại lý" && (
                        <div className="edit-agent-history-tab">
                            <div className="edit-agent-history-table-wrapper">
                                <table className="edit-agent-history-table">
                                    <thead>
                                        <tr>
                                            <th>Tạo bởi</th>
                                            <th>Duyệt bởi</th>
                                            <th>Ngày tạo</th>
                                            <th>Ngày duyệt</th>
                                            <th>ID đại lý</th>
                                            <th>User ID</th>
                                            <th>Mã KH Đại lý</th>
                                            <th>Loại giao dịch</th>
                                            <th>Trạng thái</th>
                                            <th>CBNV quản lý</th>
                                            <th>Branch quản lý</th>
                                            <th>Chi tiết</th>
                                            <th>Ghi chú</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {isLoadingHistory && (
                                            <tr><td colSpan="13" style={{ textAlign: 'center', padding: 20 }}>Đang tải dữ liệu...</td></tr>
                                        )}
                                        {!isLoadingHistory && history.length === 0 && (
                                            <tr><td colSpan="13" style={{ textAlign: 'center', padding: 20 }}>Chưa có lịch sử</td></tr>
                                        )}

                                        {!isLoadingHistory && history.map((item, index) => (
                                            <tr key={item.id || index} className={index === 0 ? "edit-history-row-selected" : ""}>
                                                <td>{item.performed_by}</td>
                                                <td>{item.approved_by || "-"}</td>
                                                <td>{formatDate(item.performed_at)}</td>
                                                <td>{formatDate(item.approved_at)}</td>
                                                <td>{agent.idDltt || agent.id}</td>
                                                <td>{item.performed_by}</td>
                                                <td>{agent.cifDltt || agent.cif_number}</td>
                                                <td>{mapActionType(item.action_type)}</td>
                                                <td>{item.approved_at ? "Đã duyệt" : "Hoàn thành"}</td>
                                                <td>{agent.tenCbnvQuanLy || agent.manager_name}</td>
                                                <td>{agent.branchQuanLy || agent.branch_code}</td>

                                                {/* Nút View */}
                                                <td
                                                    className="edit-user-history-view"
                                                    style={{ cursor: 'pointer', color: 'blue' }}
                                                    // Lưu ý: Cần chắc chắn bạn đã khai báo state handleUserHistoryDetail ở component này
                                                    // Nếu chưa có thì cần thêm state setUserHistoryDetail và setIsUserHistoryDetailOpen
                                                    onClick={() => {
                                                        // Fallback logic nếu chưa có hàm handleUserHistoryDetail
                                                        const detail = {
                                                            fieldName: "Chi tiết thay đổi",
                                                            oldValue: item.old_value ? JSON.stringify(item.old_value) : "",
                                                            newValue: item.new_value ? JSON.stringify(item.new_value) : ""
                                                        };
                                                        // Gọi prop hoặc set state
                                                        // Hoặc set trực tiếp nếu state nằm trong file này (như file mẫu cũ)
                                                        setUserHistoryDetail(detail); setIsUserHistoryDetailOpen(true);
                                                    }}
                                                >
                                                    View
                                                </td>
                                                <td>{item.reason}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                    {/* --- CẬP NHẬT TAB LỊCH SỬ USER --- */}
                    {activeTab === "Lịch sử User" && (
                        <div className="edit-user-history-tab">
                            <div className="edit-user-history-table-wrapper">
                                <table className="edit-user-history-table">
                                    <thead>
                                        <tr>
                                            <th>Tạo bởi</th>
                                            <th>Duyệt bởi</th>
                                            <th>Ngày tạo</th>
                                            <th>Ngày duyệt</th>
                                            <th>Username</th>
                                            <th>User ID</th>
                                            <th>Mã KH</th>
                                            <th>Loại giao dịch</th>
                                            <th>Trạng thái</th>
                                            <th>CBNV quản lý</th>
                                            <th>Branch quản lý</th>
                                            <th>Chi tiết</th>
                                            <th>Ghi chú</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {isLoadingUserHistory && (
                                            <tr><td colSpan="13" style={{ textAlign: "center", padding: 20 }}>Đang tải dữ liệu...</td></tr>
                                        )}
                                        {!isLoadingUserHistory && userHistory.length === 0 && (
                                            <tr><td colSpan="13" style={{ textAlign: "center", padding: 20 }}>Chưa có lịch sử user</td></tr>
                                        )}

                                        {!isLoadingUserHistory && userHistory.map((item, index) => (
                                            <tr key={item.id || index} className={index === 0 ? "edit-user-history-selected" : ""}>
                                                <td>{item.performed_by}</td>
                                                <td>{item.approved_by || "-"}</td>
                                                <td>{formatDate(item.performed_at)}</td>
                                                <td>{formatDate(item.approved_at)}</td>

                                                {/* Username/UserID/Mã KH: Fallback nếu API thiếu */}
                                                <td>{item.username || item.target_username || "-"}</td>
                                                <td>{item.user_id || item.target_user_id || "-"}</td>
                                                <td>{item.cif || "-"}</td>

                                                <td>{mapActionType(item.action_type)}</td>
                                                <td>{item.approved_at ? "Đã duyệt" : "Hoàn thành"}</td>

                                                <td>{agent.tenCbnvQuanLy || agent.manager_name}</td>
                                                <td>{agent.branchQuanLy || agent.branch_code}</td>

                                                <td
                                                    className="edit-user-history-view"
                                                    onClick={() => handleViewHistoryDetail(item)}
                                                >
                                                    View
                                                </td>
                                                <td>{item.reason}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                    {activeTab === "Hồ sơ đăng ký" && (
                        <div className="edit-doc-container">

                            {/* Tải lên tài liệu */}
                            <div className="edit-doc-upload-bar">
                                <input
                                    type="file"
                                    id="edit-doc-file-input"
                                    multiple
                                    accept=".jpg,.jpeg,.png,.pdf"
                                    style={{ display: "none" }}
                                    // Gọi hàm upload ngay khi chọn file
                                    onChange={handleDocUpload}
                                />

                                <button
                                    className="edit-doc-upload-btn"
                                    onClick={() => document.getElementById("edit-doc-file-input").click()}
                                    disabled={isLoadingDocs}
                                >
                                    <img src="/icons/icons8-upload-100.png" className="edit-doc-upload-icon" alt="upload" />
                                    {isLoadingDocs ? "Đang tải lên..." : "Tải lên tài liệu"}
                                </button>

                                <span className="edit-doc-note">
                                    (Hỗ trợ JPG, PNG, PDF. Tối đa 10 tệp, mỗi tệp 10MB.)
                                </span>
                            </div>

                            {/* TABLE */}
                            <table className="edit-doc-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: 60 }}>STT</th>
                                        <th>Tên hồ sơ</th>
                                        <th style={{ width: 180 }}>Dung lượng</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {isLoadingDocs && (
                                        <tr>
                                            <td colSpan={3} className="edit-doc-empty">
                                                Đang đồng bộ dữ liệu...
                                            </td>
                                        </tr>
                                    )}

                                    {!isLoadingDocs && savedDocs.length === 0 && (
                                        <tr>
                                            <td colSpan={3} className="edit-doc-empty">
                                                Chưa có tài liệu nào
                                            </td>
                                        </tr>
                                    )}

                                    {/* Render danh sách từ Server */}
                                    {!isLoadingDocs && savedDocs.map((f, index) => (
                                        <tr key={f.id || index}>
                                            <td>{index + 1}</td>

                                            <td>
                                                <a
                                                    href={f.file_url} // Giữ href để chuột phải vẫn có tác dụng
                                                    onClick={(e) => handleDownloadFile(e, f.file_url, f.file_name)} // <--- THÊM DÒNG NÀY
                                                    className="edit-doc-link"
                                                    title="Bấm để tải về"
                                                    style={{ cursor: "pointer" }} // Đảm bảo con trỏ chuột hiển thị đúng
                                                >
                                                    {f.file_name}
                                                </a>
                                                {/* Hiển thị label Đã lưu cho uy tín */}
                                            </td>

                                            <td className="edit-doc-size-cell">
                                                <img src="/icons/icons8-docs-100.png" className="edit-doc-file-icon" alt="file" />
                                                ({formatFileSize(f.file_size)})

                                                {/* Nút Xóa: Đã hoạt động */}
                                                <span
                                                    className="edit-doc-remove"
                                                    title="Xóa hồ sơ này"
                                                    style={{ cursor: "pointer", opacity: 1 }}
                                                    onClick={() => handleDeleteClick(f.id)}
                                                >×
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                </div>

                {/* FOOTER */}
                {(activeTab === "Thông tin Đại lý" || activeTab === "Hạn mức" || activeTab === "Hồ sơ đăng ký") && (
                    <div className="edit-agent-footer">
                        <button className="edit-agent-btn-cancel" onClick={onClose}>
                            Quay về
                        </button>
                        <button
                            className="edit-agent-btn-save"
                            onClick={handleSaveClick} // Vẫn gọi hàm xử lý chung
                        >
                            Lưu thay đổi
                        </button>
                    </div>
                )}
            </div>
            <EditUserModal
                isOpen={isUserModalOpen}
                onClose={() => setIsUserModalOpen(false)}
                user={selectedUser}
                agentId={agent.id}         // <--- QUAN TRỌNG ĐỂ LOOKUP
                agentCif={form.cifDltt} // hoặc agent.cifDltt
                agentName={form.tenDltt} // hoặc agent.tenDltt
                onSave={() => {
                    setIsUserModalOpen(false); // Đóng popup sửa
                    fetchUsers(); // GỌI LẠI HÀM NÀY ĐỂ REFRES DỮ LIỆU TAB 3
                }}
            />
            <ConfirmActionModal
                isOpen={openUserActionModal}
                message={userActionMessage[userActionType]}
                requireReason={true}
                onCancel={() => setOpenUserActionModal(false)}

                // GỌI HÀM API MỚI Ở ĐÂY
                onConfirm={handleConfirmUserStatus}
            />
            <HistoryDetailModal
                isOpen={isUserHistoryDetailOpen}
                onClose={() => setIsUserHistoryDetailOpen(false)}
                detail={userHistoryDetail}
            />
            <ConfirmCreateModal
                isOpen={isConfirmDeleteOpen}
                message="Bạn có chắc chắn muốn xóa hồ sơ này?"
                onConfirm={executeDeleteDoc}
                onCancel={() => setIsConfirmDeleteOpen(false)}
            />
        </div>
    );
}
